/* === Desktop Drawer for option_2 — v2 === */
(function () {
  if (window.__desktopDrawerInit) return;
  window.__desktopDrawerInit = true;

  const originalDrawer = document.querySelector('drawer-nav#wt-drawer-nav');
  if (!originalDrawer) return;

  const header = document.querySelector('page-header');
  if (!header) return;
  if (header.classList.contains('wt-header--v3') || header.classList.contains('wt-header--fashion')) return;
  if (document.body.classList.contains('mobile-nav')) return;

  const clone = document.createElement('div');
  clone.id = 'wt-drawer-nav-clone';
  clone.className = 'wt-drawer--clone';
  clone.innerHTML = originalDrawer.innerHTML;

  clone.querySelectorAll('mega-menu-section').forEach(function (el) {
    const div = document.createElement('div');
    for (let i = 0; i < el.attributes.length; i++) {
      div.setAttribute(el.attributes[i].name, el.attributes[i].value);
    }
    div.innerHTML = el.innerHTML;
    el.replaceWith(div);
  });

  document.body.appendChild(clone);

  const hamburger = document.querySelector('.wt-header__aside .wt-header__menu-trigger');
  if (!hamburger) return;

  const cloneClose = clone.querySelector('.wt-drawer__close');
  const cloneOverlay = document.createElement('div');
  cloneOverlay.classList.add('wt-drawer-clone-overlay');
  document.body.appendChild(cloneOverlay);

  let isOpen = false;

  function open() {
    isOpen = true;
    document.body.classList.add('clone-drawer-open');

    clone.querySelectorAll('a[data-menu-level="1"]').forEach((a) => a.setAttribute('tabindex', '0'));
    clone
      .querySelectorAll('a.wt-page-nav-mega__aside-list__link')
      .forEach((a) => a.setAttribute('tabindex', '0'));

    if (cloneClose) {
      cloneClose.setAttribute('tabindex', '0');
      cloneClose.focus();
    }
  }

  function close() {
    isOpen = false;
    document.body.classList.remove('clone-drawer-open');
    document.body.classList.remove('menu-drawer-overlay-on');

    clone.querySelectorAll('a[data-menu-level="1"]').forEach((a) => a.setAttribute('tabindex', '-1'));
    clone.querySelectorAll('a[data-menu-level="2"]').forEach((a) => a.setAttribute('tabindex', '-1'));
    clone.querySelectorAll('a[data-menu-level="3"]').forEach((a) => a.setAttribute('tabindex', '-1'));
    clone
      .querySelectorAll('a.wt-page-nav-mega__aside-list__link')
      .forEach((a) => a.setAttribute('tabindex', '-1'));

    clone.querySelectorAll('.submenu-opened').forEach((el) => el.classList.remove('submenu-opened'));

    if (cloneClose) cloneClose.setAttribute('tabindex', '-1');
    hamburger.focus();
  }

  hamburger.addEventListener(
    'click',
    function (e) {
      if (window.innerWidth >= 1200) {
        e.preventDefault();
        e.stopImmediatePropagation();
        isOpen ? close() : open();
      }
    },
    true
  );

  if (cloneClose) {
    cloneClose.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        close();
      },
      true
    );
  }

  cloneOverlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  const enableSubmenuLinkInDrawer = !!clone
    .querySelector('.mega-menu')
    ?.hasAttribute('data-enable-submenu-link-in-drawer');

  clone.querySelectorAll('.wt-page-nav-mega__link--parent').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const isTextClick = e.target?.tagName === 'SPAN';
      if (enableSubmenuLinkInDrawer && isTextClick) {
        close();
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      const wasOpen = link.classList.contains('submenu-opened');

      clone.querySelectorAll('.wt-page-nav-mega__link--parent').forEach(function (other) {
        other.classList.remove('submenu-opened');
        const wrapper = other.nextElementSibling;
        if (wrapper) {
          wrapper.querySelectorAll('a[data-menu-level="2"]').forEach((a) => a.setAttribute('tabindex', '-1'));
          wrapper.querySelectorAll('a[data-menu-level="3"]').forEach((a) => a.setAttribute('tabindex', '-1'));
          wrapper.querySelectorAll('.submenu-opened').forEach((el) => el.classList.remove('submenu-opened'));
        }
      });

      if (!wasOpen) {
        link.classList.add('submenu-opened');
        const wrapper = link.nextElementSibling;
        if (wrapper) {
          wrapper.querySelectorAll('a[data-menu-level="2"]').forEach((a) => a.setAttribute('tabindex', '0'));
        }
      }
    });
  });

  clone.querySelectorAll('.wt-page-nav-mega__sublist__link--parent').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const isTextClick = e.target?.tagName === 'SPAN';
      if (enableSubmenuLinkInDrawer && isTextClick) {
        close();
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      const wasOpen = link.classList.contains('submenu-opened');

      clone.querySelectorAll('.wt-page-nav-mega__sublist__link--parent').forEach(function (other) {
        other.classList.remove('submenu-opened');
        const sub = other.nextElementSibling;
        if (sub) sub.querySelectorAll('a[data-menu-level="3"]').forEach((a) => a.setAttribute('tabindex', '-1'));
      });

      if (!wasOpen) {
        link.classList.add('submenu-opened');
        const sub = link.nextElementSibling;
        if (sub) sub.querySelectorAll('a[data-menu-level="3"]').forEach((a) => a.setAttribute('tabindex', '0'));
      }
    });
  });

  clone.querySelectorAll('a[data-menu-level]').forEach((a) => a.setAttribute('tabindex', '-1'));
  clone.querySelectorAll('a.wt-page-nav-mega__aside-list__link').forEach((a) => a.setAttribute('tabindex', '-1'));
  if (cloneClose) cloneClose.setAttribute('tabindex', '-1');
})();
